import script from "./LoaderItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderItem.vue?vue&type=script&setup=true&lang=js"

import "./LoaderItem.vue?vue&type=style&index=0&id=02b9e6a7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b9e6a7"]])

export default __exports__